if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.cocktailSelector = this.querySelector(".cocktail-selector #cocktailDropdown");
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cartNotification = document.querySelector("cart-notification");
        this.sideCart = document.querySelector("side-cart");
        this.prodId = this.dataset.productId;
        this.oosCountries = this.querySelector(`#oosCountries-${this.prodId}`);
        this.atcButton = this.querySelector(".product-form__submit");
        this.machineUpsell = this.querySelector("#bartesian-machine-upsell-pdp");
        this.addedMachineUpsell = false;
        this.machineUpsell?.addEventListener("change", (event) => {
          if (event.target.checked) {
            this.addedMachineUpsell = true;
          } else {
            this.addedMachineUpsell = false;
          }
        });

        if (this.atcButton && !this.atcButton.hasAttribute('data-button-invalid')) {
          this.atcButton.removeAttribute("disabled");
        }
      }

      async connectedCallback() {
        if (!this.oosCountries) return;
        const oosCountries = JSON.parse(this.oosCountries.innerHTML)["oos_countries"];
        const currentCountry = await getGeolocation();
        if (!currentCountry) return;
        if (!whiteListCountries.includes(currentCountry)) {
          this.disableButton("unavailable");
        } else {
          if (oosCountries && oosCountries.includes(currentCountry)) this.disableButton("oos");
        }
      }

      disableButton(tag) {
        this.atcButton.innerHTML = tag === "oos" ? "Sold Out" : "Unavailable";
        this.atcButton.setAttribute("disabled", "");
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.isSubmitting) return;
        this.isSubmitting = true;
        if (!this.sideCart) this.cartNotification.setActiveElement(document.activeElement);

        const submitButton = this.querySelector('[type="submit"]');

        submitButton.setAttribute("disabled", true);
        submitButton.classList.add("loading");

        let thisQty;
        if (this.form.querySelector("quantity-input input")) {
          thisQty = this.form.querySelector("quantity-input input").value;
        } else {
          thisQty = 1;
        }

        const body = JSON.stringify({
          ...JSON.parse(serializeForm(this.form, thisQty)),
          sections: this.cartNotification.getSectionsToRender().map((section) => section.id),
          sections_url: window.location.pathname,
        });

        if (this.sideCart) {
          const itemJson = JSON.parse(body);
          console.log("itemJson", itemJson);

          if (itemJson["custom-availability"] === "true") {
            console.log("custom-availability -> true");
            const varId = itemJson.id;
            const sellingPlan = itemJson.selling_plan;
            let varqty = parseInt(itemJson.quantity);
            console.log("sellingPlan", sellingPlan);
            console.log("properties", itemJson.properties);

            const matchedEarlyAccessObject = earlyAccessData.find(
              (item) => item.earlyAccessVariantId == varId
            );

            if (qtyLimitEnabled) {
              const totalEarlyAccessProductQty =
                parseInt(
                  this.sideCart
                    .querySelector(
                      `side-cart-item[data-variant-id="${matchedEarlyAccessObject?.earlyAccessVariantId}"] #itemQty`
                    )
                    ?.getAttribute("value")
                ) + varqty;

              if (matchedEarlyAccessObject) {
                const existingHelpMessage = document.querySelector(
                  ".gating-product-qty-limit-message"
                );

                if (
                  totalEarlyAccessProductQty >
                    matchedEarlyAccessObject.earlyAccessProductQtyLimit &&
                  matchedEarlyAccessObject.earlyAccessProductQtyLimit > 0
                ) {
                  if (!existingHelpMessage) {
                    const helpMessage = document.createElement("div");
                    helpMessage.classList.add("gating-product-qty-limit-message");
                    helpMessage.innerHTML = `You can buy up to ${matchedEarlyAccessObject.earlyAccessProductQtyLimit} sets of ${matchedEarlyAccessObject.earlyAccessVariantTitle}.`;
                    this.atcButton.parentNode.insertBefore(helpMessage, this.atcButton);
                  }
                } else {
                  if (existingHelpMessage) {
                    existingHelpMessage.remove();
                  }

                  if (this.addedMachineUpsell) {
                    await this.sideCart.addToCart("43298614935751");
                  }

                  varqty && !isNaN(varqty)
                    ? await this.sideCart.addToCart(varId, varqty, sellingPlan, itemJson.properties)
                    : await this.sideCart.addToCart(varId, 1, sellingPlan, itemJson.properties);
                }
              } else {
                if (this.addedMachineUpsell) {
                  await this.sideCart.addToCart("43298614935751");
                }

                varqty && !isNaN(varqty)
                  ? await this.sideCart.addToCart(varId, varqty, sellingPlan, itemJson.properties)
                  : await this.sideCart.addToCart(varId, 1, sellingPlan, itemJson.properties);
              }
            } else {
              if (this.addedMachineUpsell) {
                await this.sideCart.addToCart("43298614935751");
              }

              varqty && !isNaN(varqty)
                ? await this.sideCart.addToCart(varId, varqty, sellingPlan, itemJson.properties)
                : await this.sideCart.addToCart(varId, 1, sellingPlan, itemJson.properties);
            }

            submitButton.classList.remove("loading");
            submitButton.removeAttribute("disabled");
            this.isSubmitting = false;
          } else {
            console.log("custom-availability -> false");
            this.isSubmitting = false;
          }
        } else {
          fetch(`${routes.cart_add_url}`, {
            ...fetchConfig("javascript"),
            body,
          })
            .then((response) => response.json())
            .then((parsedState) => {
              this.cartNotification.renderContents(parsedState);
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              submitButton.classList.remove("loading");
              submitButton.removeAttribute("disabled");
              this.isSubmitting = false;
            });
        }
      }
    }
  );
}
